module.exports = __webpack_public_path__ + "img/plat_dia.png";